<div class="distribucion-votos container-fluid pt-3">
    <div class="row">
        <div class="col-12">
            <div class="card p-2">
                <div class="container-fluid">
                    <div class="row pb-4">
                        <div class="col-12">
                            <p class="titulo pb-2">
                                <strong class="d-none d-xl-block">
                                    Distribución de votos por Partidos Políticos {{habilitar_label_candidaturas ? 'y Candidaturas Independientes a nivel' : 'a nivel'}} {{selectedContienda == 'gubernatura' ? 'Distrito' : labels?.contienda_s}}
                                </strong>
                                <strong class="d-block d-xl-none">
                                    Distribución de votos por Partido{{addS}} Político{{addS}} a nivel {{selectedContienda == 'gubernatura' ? 'Distrito' : labels?.contienda_s}}
                                </strong>
                            </p>
                            <p class="em14">
                                La tabla muestra el desglose de votos que cada Partido Político {{habilitar_label_candidaturas ? 'o Candidatura Independiente ' : ''}}presenta en {{labels?.contienda_s == 'Junta' ? ('la ' + labels?.contienda_s) : ('el ' + (selectedContienda == 'gubernatura' ? 'Distrito' : labels?.contienda_s))}}, indicando los votos recibidos de manera individual y, en su caso, los votos recibidos vía coalición.
                            </p>
                            <p class="em14 underline">
                                <a href="{{objConfig.distribucion_link}}">Conoce cómo se suman los votos para Candidatura de Coalición de acuerdo con la legislación vigente.</a>
                            </p>
                        </div>
                    </div>
                    <div class="d-none d-xl-block">
                        <div class="tabla pt-3">
                            <div class="titulos row pb-2 text-center">
                                <div class="col-3">
                                    <p>
                                        <strong>
                                            Partidos Políticos y <br> {{ habilitar_label_candidaturas ? 'Candidaturas Independientes' : ''}}
                                        </strong>
                                    </p>
                                </div>
                                <div class="col-3 text-center">
                                    <p>
                                        <strong *ngIf="selectedContienda == 'diputaciones'">
                                            Votos recibidos de manera<br> individual
                                        </strong>
                                        <strong *ngIf="selectedContienda != 'diputaciones'">
                                            Votos para Partidos Políticos<br> {{ habilitar_label_candidaturas ? 'y Candidatura Independiente' : ''}}
                                        </strong>
                                    </p>
                                </div>
                                <div class="col-4 text-center">
                                    <p>
                                        <strong *ngIf="selectedContienda == 'diputaciones'">
                                            Votos obtenidos por<br> Combinaciones de Coalición
                                        </strong>
                                        <strong *ngIf="selectedContienda != 'diputaciones'">
                                            Votos obtenidos via Coalición
                                        </strong>
                                    </p>
                                </div>
                                <div class="col-2 text-center">
                                    <p>
                                        <strong>
                                            Total de votos
                                        </strong>
                                    </p>
                                </div>
                            </div>
                            <div class="row datos" *ngFor="let fila of this._obtenerDatosService.desglose; let i = index;">
                                <div class="col-3">
                                    <div class="distritos py-4 w-100 dis-flex">
                                            <!-- {{ _obtenerDatosService.diccionarioPartidos[fila?.partido].imgPartido}} -->
                                        <img class="img-partido" src="{{_obtenerDatosService.pathPartidos}}{{fila?.img}}">
<!--
                                        <p class="pe dis-flex p-2"
                                           [ngStyle]="{
                                                'background-image': 'url({{_obtenerDatosService.pathPartidos}}'+ fila?.img?.toLowerCase() +')',
                                                'background-size': 'auto 27px',
                                                'background-repeat': 'no-repeat',
                                                'background-position': 'left center'
                                            }">
                                        </p>
-->
                                    </div>
                                </div>
                                <div class="col-3 dis-flex">
                                    <p class="total dis-flex mx-3 my-2">
                                        {{ fila?.partido ? fila?.partido : fila?.text}}
                                    </p>
                                </div>
                                <div class="col-1 dis-flex flex-col text-center">
                                    <div class="conteo dis-flex justify-s w-100">
                                        <div class="igual dis-flex mx-sm-3">
                                            <i class="fas fa-plus" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 total-new">
                                    <div *ngIf="!isStr(fila?.coalicion)">
                                        <p class="total dis-flex mx-3" *ngFor="let record of fila?.coalicion; let i = index;">
                                            <span *ngFor="let image of record?.img;">
                                                <img class="img-partido" [ngClass]="{'disabled-partido': image?.disabled}" src="{{_obtenerDatosService.pathPartidos}}{{image?.img}}">
                                            </span> 
                                            <span class="distribucion-plus">{{ (i > 0 ? '+' : '') }}</span> {{ record?.total }}
                                        </p>
                                    </div>
                                    <p class="total dis-flex mx-3 my-2 sin-coalicion" *ngIf="isStr(fila?.coalicion)">{{ fila?.coalicion }}</p>
                                </div>
                                <div class="col-1 dis-flex flex-col text-center">
                                    <div class="conteo dis-flex justify-s w-100">
                                        <div class="igual dis-flex mx-sm-3">
                                            <i class="fas fa-equals" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 dis-flex">
                                    <p class="total dis-flex mx-3 my-2">
                                        <strong>
                                            {{ fila?.total }}
                                        </strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Versión Móvil-->
                    <div class="d-block d-xl-none">
                        <div class="row tarjeta-mov" *ngFor="let fila of this._obtenerDatosService.desglose; let i = index;" [ngClass]="{'stripped' : i%2 == 0}">
                            <div class="col-12 row-img mb-1" >
                                <img class="img-partido" src="{{_obtenerDatosService.pathPartidos}}{{fila?.img}}">
                            </div>
                            <div class="col-6 titulo-dist">
                                <p>Votos Recibidos de<br>manera individual</p>
                            </div>
                            <div class="col-6 val-cantidad">
                                <p class="cantidad"><strong>{{ fila?.partido ? fila?.partido : fila?.text}}</strong></p>
                            </div>

                            <hr class="dist-sep">

                             <div class="col-12 total-new" style="padding: 0;">
                                <div *ngIf="!isStr(fila?.coalicion)">
                                    <div class="col-12 titulo">
                                        <p>Votos obtenidos por Combinaciones de Coalición</p>
                                    </div>
                                    <div *ngFor="let record of fila?.coalicion; let i = index;">
                                        <hr class="dist-sep" *ngIf="i != 0">
                                        <div class="total dis-flex mx-3 row-img" style="justify-content: normal !important;">
                                            <div *ngFor="let image of record?.img;">
                                                <img class="img-partido" [ngClass]="{'disabled-partido': image?.disabled}" src="{{_obtenerDatosService.pathPartidos}}{{image?.img}}">
                                            </div> 
                                            <p class="total mx-3">
                                                <span class="distribucion-plus">{{ (i >= 0 ? '+' : '') }}</span> {{ record?.total }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <p class="total dis-flex mx-3 my-2 sin-coalicion" *ngIf="isStr(fila?.coalicion)">{{ fila?.coalicion }}</p>
                            </div>

                            <hr class="total-sep">
                            <div class="col-6 grand-total">
                                <p>Total de votos</p>
                            </div>
                            <div class="col-6 grand-total">
                                <p class="val-cantidad"><strong>{{fila?.total}}</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
